// reducer.js
import {
  SET_VALUE_USER,
  SET_ACTIF_USER,
  SET_DATE_USER,
  SET_CURRENT_PAGE_USER,
  SET_ORDER_USER,
  SET_SORT_FIELD_USER,
  SET_ROLE_USER,
} from "./actionsTypes";

const initialState = {
  value: "",
  actif: "",
  date: "",
  role: "",
  currentPage: 1,
  order: "asc",
  sortField: "last_name",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_USER:
      return {
        ...state,
        value: action.payload,
      };
    case SET_ACTIF_USER:
      return {
        ...state,
        actif: action.payload,
      };
    case SET_DATE_USER:
      return {
        ...state,
        date: action.payload,
      };
    case SET_CURRENT_PAGE_USER:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_USER:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_USER:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ROLE_USER:
      return {
        ...state,
        role: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
